export default "__VITE_ASSET__Ub_whz8B__"